import React from 'react';

interface InboxBadgeProps {
  count?: number;
  hasUnread?: boolean;
  className?: string;
}

export default function InboxBadge({ count = 0, hasUnread, className }: InboxBadgeProps) {
  if (!hasUnread || count <= 0) return null;

  const label = count > 99 ? '99+' : String(count);

  return (
    <span
      className={`absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-[#7A9488] text-white text-[10px] font-semibold leading-[18px] text-center ${className ?? ''}`}
      aria-label={`${count} ongelezen inbox berichten`}
      title={`${count} ongelezen`}
    >
      {label}
    </span>
  );
}






